import { initialState } from '../schema';

// reset user data to initial state
export const reduceDeleteSessionSuccess = () => initialState;

export const reduceDeleteSessionFailure = () => initialState;
